import { SelectableModel } from '@app/component/autocomplete/abstract-autocomplete/selectable-model';

import { Country } from '../country/country';

import { Coach } from './coach/coach';
import { Employee } from './employee/employee';

export class LocalPartner extends SelectableModel {
  country!: Country;
  name!: string;

  employeeList: Employee[] = [];
  coachList: Coach[] = [];
}
